<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md12>
        <v-dialog v-model="dialog" width="1000" hegiht="auto" persistent>
          <template v-slot:activator="{ on }">
            <v-flex xs12 md4>
              <v-btn color="success" dark v-on="on">
                Create new crash course Subject
              </v-btn>
            </v-flex>
          </template>

          <v-card>
            <v-container>
              <material-card title="Create New Crash Course Subject" color="green">
                <v-form ref="formCrashCourseSubject" v-model="valid" lazy-validation>
                  <v-container py-0>
                    <v-layout wrap>
                      <v-flex md12>
                        <v-select
                          :items="crashCourseList"
                          label="Select Crash Course"
                          item-text="name"
                          item-value="id"
                          v-model="subjectObj.crash_course_id"
                          class="mt-2"
                          :rules="courseIDRules"
                        ></v-select>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field
                          type="text"
                          label="Subject Name"
                          class="green-input"
                          v-model="subjectObj.name"
                          prepend-icon="text_fields"
                          :rules="nameRules"
                        />
                      </v-flex>
                      <v-flex md6>
                        <v-text-field
                          type="text"
                          label="Subject Name (বাংলা)"
                          class="green-input"
                          v-model="subjectObj.name_bn"
                          prepend-icon="text_fields"
                        />
                      </v-flex>                   
                     
                    
                      <v-flex md6>
                        <v-text-field
                          type="number"
                          label="Sort"
                          class="green-input"
                          v-model="subjectObj.sort"
                          :rules="sortRules"
                        />
                      </v-flex>
                         <v-flex md6>
                        <v-text-field
                          type="text"
                          label="Folder Name (Must be in english)"
                          class="green-input"
                          v-model="subjectObj.folder_name"
                          :rules="folderRules" 
                        />
                      </v-flex>                 

                    

                      <v-flex xs12 text-xs-right>
                        <v-btn
                          class="mx-0 font-weight-light"
                          color="success"
                          :disabled="disableButton"
                          @click="onCrashCourseSubjectSubmit"
                          >Submit</v-btn
                        >
                        <v-btn
                          class="mx-2 font-weight-light"
                          color="info"
                          :disabled="disableButton"
                          @click="closeModal"
                          >Close</v-btn
                        >
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-form>
              </material-card>
            </v-container>
          </v-card>
        </v-dialog>
        <material-card
          color="green"
          title="Crash Course Subject List"
          text="The crash courses subject those are being provided by BacBon"
        >
          <v-data-table :headers="headers" :items="crashCourseSubjectList">
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="subheading font-weight-light text--darken-3"
                v-text="header.text"
              />
            </template>
            <template slot="items" slot-scope="{ item }">
              <td>{{ item.crash_course.name }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.is_active }}</td>
              <td>{{ item.sort }}</td>
              <td>
               <!-- <v-btn
                  color="success"
                  fab
                  small
                  dark
                  round
                  @click="enableEdit(item)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn> -->
              </td>
            </template>
          </v-data-table>

          <v-dialog v-model="dialogEdit" width="1000" hegiht="auto" persistent>
            <!--       <template v-slot:activator="{ on }">
            
          </template> -->

            <v-card>
              <!--  <FormCourseEdit
              :CourseTypeList="courseTypeList"
              :Item="item"
              :Field="inputFields"
              :Value="course"
              @emitted="EditCourse"
              @closed="closeModal"
              /> -->
            </v-card>
          </v-dialog>
        </material-card>

        <v-snackbar
          :color="color"
          :bottom="bottom"
          :top="top"
          :left="left"
          :right="right"
          v-model="snackbar"
          dark
        >
          <v-icon color="white" class="mr-3"> mdi-bell-plus </v-icon>
          <div>{{ errorMessage }}</div>
          <v-icon size="16" @click="snackbar = false">
            mdi-close-circle
          </v-icon>
        </v-snackbar>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import FormCourseEdit from "@/views/FormCourseEdit";
export default {
  components: {
    FormCourseEdit,
  },
  computed: {
    ...mapState("crashCourseSubjects", ["crashCourseList","crashCourseSubjectList"]),
  },
  mounted() {
    this.getCrashCourseSubjectlist();
    this.getCrashCourselist();
  },
  data() {
    return {  
      valid: true,
      color: null,
      colors: ["warning"],
      top: true,
      bottom: false,
      left: false,
      right: false,
      snackbar: false,
      course: {},
      headers: [
        {
          sortable: false,
          text: "Crash Course",
          value: "name",
        },
        {
          sortable: false,
          text: "Crash Course Subject",
          value: "name",
        },    
        {
          sortable: false,
          text: "Sort",
          value: "sort",
        },
        {
          sortable: false,
          text: "Action",
          value: "action",
        },
      ],
      dialog: false,
      dialogEdit: false,
      errorMessage: "",
      item: {
        title: "Create New Crash Course Subject",
        subTitle: "This is the subtitle",
        width: "md6",
        submitText: "Submit",
      },
      subjectObj: {},   
      courseIDRules: [(v) => !!v || "Thumbnail is required."],
      nameRules: [
        (v) => !!v || "Course name is required",
        (v) =>
          (v && v.length <= 190) ||
          "Course name must be less than 190 characters"
      ],     
      sortRules: [(v) => !!v || "Sort is required"],    
      folderRules: [(v) => !!v || "Folder name is required"],
      disableButton: false,

    
    };
  },
  created() {
    // this.getCourseTypeList()
  },
  methods: {
    ...mapActions("crashCourseSubjects", [
      "createCrashCourseSubject",
      "getCrashCourselist",
      "getCrashCourseSubjectlist",
      "updateCourse",
    ]),
    enableEdit(item) {
      this.course = item;
      this.dialogEdit = true;
    },
    closeModal() {
      this.dialog = false;
      this.$refs.formCrashCourseSubject.reset();
      this.subjectObj = {}
    },  
    onCrashCourseSubjectSubmit() {
  
      if (this.$refs.formCrashCourseSubject.validate()) {
 
      
        this.disableButton = true;

        this.createCrashCourseSubject(this.subjectObj)
          .then((response) => {
            
            if (response.status == "OK") {
              this.closeModal();
               this.$refs.formCrashCourseSubject.resetValidation();
              this.disableButton = false;
              this.getCrashCourseSubjectlist();
              this.getCrashCourselist();
              this.color = "success";
              this.errorMessage = response.messages;
              this.snack("top");
            } else {
              this.errorMessage = response.messages;
              this.snack("top");
              this.disableButton = false;
            }
          })
          .catch((err) => {
            this.disableButton = false;
            console.log(err);
          });
      } else {
      }
    },

    // EditCourse(data) {
    //   this.updateCourse(data)
    //     .then((response) => {
    //       if (response.status == "OK") {
    //         this.getCrashCourselist();
    //         this.dialogEdit = false;
    //         this.color = "success";
    //         this.errorMessage = response.messages;
    //         this.snack("top");
    //       } else {
    //         this.dialogEdit = false;
    //         this.color = "warning";
    //         this.errorMessage = response.messages;
    //         this.snack("top");
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },
    // getBackData(data) {
    //   this.CreateCourse(data)
    //     .then((response) => {
    //       console.log(response);
    //       if (response.status == "OK") {
    //         this.getCrashCourselist();
    //         this.dialog = false;
    //         this.color = "success";
    //         this.errorMessage = response.messages;
    //         this.snack("top");
    //       } else {
    //         this.dialog = false;
    //         this.color = "warning";
    //         this.errorMessage = response.messages;
    //         this.snack("top");
    //       }
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // },


    snack(...args) {
      this.top = false;
      this.bottom = false;
      this.left = false;
      this.right = false;

      for (const loc of args) {
        this[loc] = true;
      }

      this.color = this.colors[Math.floor(Math.random() * this.colors.length)];

      this.snackbar = true;
    },
  },
};
</script>
